import React from "react";

export function Card({ children, className = "", ...props }) {
  return (
    <div className={`rounded-3xl border border-green-600/30 bg-gradient-to-br from-black via-neutral-950 to-green-950/40 ${className}`} {...props}>
      {children}
    </div>
  );
}

export function CardContent({ children, className = "", ...props }) {
  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
}

export default Card;
